import React, { useState } from 'react';

const QUESTIONS = [
  { key: 'role', label: 'You are a', options: ['Homeowner', 'Investor', 'Builder', 'Architect'] },
  { key: 'planning', label: 'Planning', options: ['Kitchen', 'Bathroom', 'Full refurb', 'Extension'] },
  { key: 'starting', label: 'Starting', options: ['Within 3 months', '3 to 12 months', 'Just researching'] },
  { key: 'budget', label: 'Rough budget', options: ['Under £25k', '£25k to £75k', '£75k+'] },
  { key: 'value', label: 'A priced schedule for your project is worth', options: ['Under £50', '£50 to £100', '£100 to £200', '£200+'] },
];

const slug = (s) => s.toLowerCase().replace(/£/g, '').replace(/\+/g, 'plus').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const SurveyStep = ({ initialRole, onSend, onSkip, busy }) => {
  const [answers, setAnswers] = useState({ role: initialRole || null });
  const toggle = (key, opt) => setAnswers((a) => ({ ...a, [key]: a[key] === opt ? null : opt }));

  return (
    <div className="fm-panel" data-testid="survey-panel">
      <h2 className="fm-panel-h">You're in.</h2>
      <p className="fm-panel-p">Help us shape the service. Five quick taps, all optional.</p>
      {QUESTIONS.map((q) => (
        <fieldset key={q.key} className="fm-q" data-testid={`survey-q-${q.key}`}>
          <legend className="fm-q-label">{q.label}</legend>
          <div className="fm-chips">
            {q.options.map((opt) => (
              <button
                key={opt}
                type="button"
                className={`fm-chip${answers[q.key] === opt ? ' on' : ''}`}
                aria-pressed={answers[q.key] === opt}
                onClick={() => toggle(q.key, opt)}
                data-testid={`chip-${q.key}-${slug(opt)}`}
              >{opt}</button>
            ))}
          </div>
        </fieldset>
      ))}
      <div className="fm-panel-actions">
        <button type="button" className="fm-btn-primary" disabled={busy} onClick={() => onSend(answers)} data-testid="survey-send-btn">
          {busy ? 'Sending…' : 'Send answers'}
        </button>
        <button type="button" className="fm-btn-ghost" disabled={busy} onClick={onSkip} data-testid="survey-skip-btn">Skip</button>
      </div>
    </div>
  );
};
